class WorkGrid extends HTMLElement {
  constructor() {
    super();
    this.cards = null;
  }

  connectedCallback() {
    this.cards = this.querySelectorAll(".work-card");
    
    // Initialize dialog triggers for work cards
    this.initDialogTriggers();

    if (!this.cards) return;

    if (navigator.maxTouchPoints > 1) {
      document.body.addEventListener("touchstart", () => {
        this.cards.forEach(card => {
          let video = card.querySelector("video");
          if (video) {
            video.play().then(() => {
              video.pause(); // Pause immediately after playing once to "unlock" autoplay
              video.currentTime = 0;
            }).catch(() => {}); // Catch any potential play() errors silently
          }
        });
      }, { once: true });

      this.cards.forEach(card => {
        let video = card.querySelector("video");
        if (video) {
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                video.play();
                // Preload dialog video if available
                if (window.workDialog) {
                  window.workDialog.preloadMedia(card);
                }
              } else {
                video.pause();
                video.currentTime = 0;
              }
            });
          }, { threshold: 0, rootMargin: '400px' });

          observer.observe(card);
        }
      });
    } else if(navigator.maxTouchPoints === 1) {
      this.cards.forEach(card => {
        let video = card.querySelector("video");
        if (video) {
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                video.play();
                // Preload dialog video if available
                if (window.workDialog) {
                  window.workDialog.preloadMedia(card);
                }
              } else {
                video.pause();
                video.currentTime = 0;
              }
            });
          }, { threshold: 0, rootMargin: '400px' });

          observer.observe(card);
        }
      });
    } else {
      this.cards.forEach(card => {
        let video = card.querySelector("video");
        if (video) {
          video.addEventListener("mouseenter", e => {
            e.preventDefault();
            video.play();
          });

          video.addEventListener("mouseleave", e => {
            e.preventDefault();
            video.pause();
            video.currentTime = 0;
          });
        }
      });
    }
  }

  initDialogTriggers() {
    // Track if triggers are already set up to prevent duplicates
    if (this._triggersSetup) return;
    
    const setupTriggers = () => {
      if (this._triggersSetup) return; // Prevent duplicate setup
      this._triggersSetup = true;
      
      // Handle clicks on work cards that have work-data script tags
      this.cards.forEach(card => {
        // Preload media on hover - remove old listener first
        const mouseEnterHandler = () => {
          if (window.workDialog) {
            window.workDialog.preloadMedia(card);
          }
        };
        if (card._workDialogMouseEnter) {
          card.removeEventListener("mouseenter", card._workDialogMouseEnter);
        }
        card._workDialogMouseEnter = mouseEnterHandler;
        card.addEventListener("mouseenter", mouseEnterHandler);

        // Open dialog on click - remove old listener first
        const clickHandler = (e) => {
          // Check if card has work data
          const hasWorkData = card.querySelector('script.work-data');
          if (hasWorkData && window.workDialog) {
            e.preventDefault();
            window.workDialog.open(card);
          } 
        };
        if (card._workDialogClick) {
          card.removeEventListener('click', card._workDialogClick);
        }
        card._workDialogClick = clickHandler;
        card.addEventListener('click', clickHandler);
      });
    };

    // Wait for dialog to be ready if it's not already initialized
    if (window.workDialog && window.workDialog.dialog) {
      setupTriggers();
    } else {
      let setupComplete = false;
      
      // Listen for dialog ready event
      const handleDialogReady = () => {
        if (!setupComplete) {
          setupComplete = true;
          setupTriggers();
          window.removeEventListener('workDialogReady', handleDialogReady);
          if (fallbackTimeout) clearTimeout(fallbackTimeout);
        }
      };
      window.addEventListener('workDialogReady', handleDialogReady);
      
      // Fallback: try after a short delay
      const fallbackTimeout = setTimeout(() => {
        if (!setupComplete && window.workDialog && window.workDialog.dialog) {
          setupComplete = true;
          setupTriggers();
          window.removeEventListener('workDialogReady', handleDialogReady);
        }
      }, 500);
    }
  }
}

customElements.define("work-grid", WorkGrid);